<div mat-dialog-title>
  Manual lineups
</div>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Away lineup">
      <div class="lineup-container">
        <h3>Away Lineup</h3>

        <!-- Add player to lineup -->
        <div class="add-player-section">
          <mat-form-field appearance="fill">
            <mat-label>Select Player</mat-label>
            <mat-select #awayPlayer>
              <mat-option *ngFor="let player of awayRoster" [value]="player">
                #{{player.number}} - {{player.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="position-dropdown">
            <mat-label>Position</mat-label>
            <mat-select #awayPosition>
              <mat-option *ngFor="let position of positions" [value]="position.value">
                {{position.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-flat-button color="primary" (click)="addPlayerToAwayLineup(awayPlayer.value, awayPosition.value)">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>

        <!-- Current lineup -->
        <div class="current-lineup">
          <h4>Current Lineup</h4>
          <table class="lineup-table" cdkDropList (cdkDropListDropped)="dropAwayLineup($event)">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Position</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let player of broadcast.manualLineups?.awayLineup; let i = index" cdkDrag class="lineup-row">
                <td>{{player.number}}</td>
                <td>{{player.name}}</td>
                <td>{{utilService.positionToLabel(player.position)}}</td>
                <td>
                  <button mat-icon-button color="warn" (click)="removePlayerFromAwayLineup(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Away Pitcher -->
        <div class="pitcher-section">
          <h4>Away Pitcher or FLEX</h4>
          <div class="pitcher-inputs">
            <mat-form-field appearance="fill">
              <mat-label>Select Pitcher or FLEX</mat-label>
              <mat-select [(value)]="selectedAwayPitcher" (selectionChange)="setAwayPitcher($event.value)">
                <mat-option [value]="null">None</mat-option>
                <mat-option *ngFor="let player of awayRoster" [value]="player">
                  #{{player.number}} - {{player.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="position-dropdown">
              <mat-label>Position</mat-label>
              <mat-select [(value)]="awayPitcherPosition" [disabled]="awayPitcherPositionDisabled">
                <mat-option *ngFor="let position of positions" [value]="position.value">
                  {{position.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-flat-button color="primary" *ngIf="selectedAwayPitcher" (click)="setAwayPitcher(selectedAwayPitcher, awayPitcherPosition)">
              <mat-icon>update</mat-icon> Update
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Home lineup">
      <div class="lineup-container">
        <h3>Home Lineup</h3>

        <!-- Add player to lineup -->
        <div class="add-player-section">
          <mat-form-field appearance="fill">
            <mat-label>Select Player</mat-label>
            <mat-select #homePlayer>
              <mat-option *ngFor="let player of homeRoster" [value]="player">
                #{{player.number}} - {{player.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="position-dropdown">
            <mat-label>Position</mat-label>
            <mat-select #homePosition>
              <mat-option *ngFor="let position of positions" [value]="position.value">
                {{position.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-flat-button color="primary" (click)="addPlayerToHomeLineup(homePlayer.value, homePosition.value)">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>

        <!-- Current lineup -->
        <div class="current-lineup">
          <h4>Current Lineup</h4>
          <table class="lineup-table" cdkDropList (cdkDropListDropped)="dropHomeLineup($event)">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Position</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let player of broadcast.manualLineups?.homeLineup; let i = index" cdkDrag class="lineup-row">
                <td>{{player.number}}</td>
                <td>{{player.name}}</td>
                <td>{{utilService.positionToLabel(player.position)}}</td>
                <td>
                  <button mat-icon-button color="warn" (click)="removePlayerFromHomeLineup(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Home Pitcher -->
        <div class="pitcher-section">
          <h4>Home Pitcher or FLEX</h4>
          <div class="pitcher-inputs">
            <mat-form-field appearance="fill">
              <mat-label>Select Pitcher or FLEX</mat-label>
              <mat-select [(value)]="selectedHomePitcher" (selectionChange)="setHomePitcher($event.value)">
                <mat-option [value]="null">None</mat-option>
                <mat-option *ngFor="let player of homeRoster" [value]="player">
                  #{{player.number}} - {{player.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="position-dropdown">
              <mat-label>Position</mat-label>
              <mat-select [(value)]="homePitcherPosition" [disabled]="homePitcherPositionDisabled">
                <mat-option *ngFor="let position of positions" [value]="position.value">
                  {{position.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-flat-button color="primary" *ngIf="selectedHomePitcher" (click)="setHomePitcher(selectedHomePitcher, homePitcherPosition)">
              <mat-icon>update</mat-icon> Update
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">
    Close
  </button>
  <button mat-flat-button color="primary" (click)="update()" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Update
  </button>
</div>
